<h2 class="default-dialog-header font-weight-normal" mat-dialog-title>
	<span fxFlex> {{ dialogHeader }} </span>
	<span fxFlex="10" fxLayoutAlign="end end">
		<mat-icon (click)="closeDialog(null)" class="primary-light-color cursor-pointer">
			close
		</mat-icon>
	</span>
</h2>
<mat-divider></mat-divider>

<mat-dialog-content class="default-dialog-content">
	<form
		(keydown.enter)="$event.preventDefault()"
		[formGroup]="rateDetailsForm"
		class="full-width"
		*ngIf="showRateForm"
	>
		<div fxLayout="row" fxLayoutGap="1rem" class="m-t-1">
			<div fxFlex>
				<mat-form-field class="full-width">
					<mat-icon class="primary-light-color vertical-align-bottom" matPrefix
						>attach_money
					</mat-icon>
					<input
						autocomplete="off"
						formControlName="desiredPrice"
						mask="separator"
						thousandSeparator=","
						prefix="$"
						matInput
						placeholder="Carrier Rate"
					/>
				</mat-form-field>
			</div>

			<div fxFlex>
				<mat-form-field class="full-width">
					<input
						(click)="picker1.open()"
						[formControl]="carrierRespondedAt"
						[matDatepicker]="picker1"
						matInput
						placeholder="Rate Received"
					/>
					<mat-datepicker-toggle [for]="picker1" matSuffix tabIndex="-1"></mat-datepicker-toggle>
					<mat-datepicker #picker1></mat-datepicker>
				</mat-form-field>
			</div>
		</div>
	</form>

	<div fxLayout="row" fxLayoutAlign="center center" *ngIf="showNotes">
		<app-note-list
			[name]="dialogData.carrierBusinessName"
			[id]="dialogData.carrierIds[0]"
			[defaultFeedback]="[]"
			[feedbackInformation]="dialogData.feedbackInformation"
			[showFeedback]="true"
			[edit]="false"
			fxFlex
		>
		</app-note-list>
	</div>
</mat-dialog-content>

<mat-dialog-actions class="default-dialog-action">
	<div fxFlex="50" fxLayoutAlign="start center" fxLayoutGap="0.5rem">
		<mat-checkbox [(ngModel)]="hideEngageCarriersDialog" [labelPosition]="'after'" color="primary">
			Do Not Ask Again
		</mat-checkbox>
	</div>

	<div fxFlex="50" fxLayoutAlign="end end" fxLayoutGap="0.5rem">
		<button (click)="submitForm()" color="primary" mat-raised-button [disabled]="isFormSubmitted">
			{{ submitButtonText }}
		</button>
	</div>
</mat-dialog-actions>
